function hideLoader() {
    document.querySelector('#preloader').classList.remove('active');
}

export default hideLoader;